<template>
    <div>
        <!-- <v-row>
            <v-col cols="6">
                <v-row v-for="(n, index) in contents"  v-if="n.Title.split('#')[0] == 'Deputy Attorney General'" :key="index + 'DG'">
                    <v-col cols="6" md="5">
                        <v-card height="170" class="align-center elevation-2" style="border-radius: 50%">
                            <v-img
                            height="170"
                            contain
                            :src="`${$url}/downloadfile/${n.Files[0] ? n.Files[0].ID : ''}`"
                            :lazy-src="`${$url}/downloadfile/${n.Files[0] ? n.Files[0].ID : ''}`"
                            class="transparent lighten-2 white--text align-end"
                            >
                                <template v-slot:placeholder>
                                    <v-layout
                                        fill-height
                                        align-center
                                        justify-center
                                        ma-0
                                        >
                                        <v-progress-circular indeterminate color="grey lighten-2"></v-progress-circular>
                                    </v-layout>
                                </template>
                            </v-img>
                        </v-card>
                    </v-col>
                    <v-col cols="6" md="7">
                        <div class="d-flex align-center" style="height: 170px">
                            <p class="mt-3 text-xs-center"><a :href="`#/About Us/Management/Profile/Deputy Attorney General`" class="title">{{n.Title.split('#').length > 0 ? n.Title.split('#')[1] : ''}}</a><br>
                            <span class="subheading text-xs-center">{{n.Title.split('#')[0]}}</span><br> </p>
                        </div>
                    </v-col>
                </v-row>
            </v-col>
            <v-col cols="6"></v-col>
        </v-row> -->
        <div v-for="(n, index) in contents"  v-if="n.Title.split('#')[0] == 'Deputy Attorney General'" :key="index + 'DG'">
            <v-row>
                <v-col cols="4" md="2">
                    <v-card class="elevation-2">
                        <v-img
                        max-height="200" 
                        contain
                        :src="`${$url}/downloadfile/${n.Files[0] ? n.Files[0].ID : ''}`"
                        class="transparent lighten-2"
                        >
                            <template v-slot:placeholder>
                            <v-layout
                                fill-height
                                align-center
                                justify-center
                                ma-0
                                >
                                <v-progress-circular indeterminate color="grey lighten-1"></v-progress-circular>
                            </v-layout>
                            </template>
                        </v-img>
                    </v-card>
                </v-col>
            </v-row>
            <p class="mt-3 text-xs-center"><a :href="`#/About Us/Senior Management/Profile/Deputy Attorney General`" class="title">{{n.Title.split('#').length > 0 ? n.Title.split('#')[1] : ''}}</a><br>
            <span class="subheading text-xs-center">{{n.Title.split('#')[0]}}</span><br> </p>
        </div>
        <div v-for="(n, index) in contents"  v-if="n.Title.split('#')[0] == 'Permanent Secretary'" :key="index + 'PS'">
            <v-row>
                <v-col cols="4" md="2">
                    <v-card class="elevation-2">
                    <v-img
                    max-height="200" 
                    contain
                    :src="`${$url}/downloadfile/${n.Files[0] ? n.Files[0].ID : ''}`"
                    class="transparent lighten-2"
                    >
                        <template v-slot:placeholder>
                        <v-layout
                            fill-height
                            align-center
                            justify-center
                            ma-0
                            >
                            <v-progress-circular indeterminate color="grey lighten-1"></v-progress-circular>
                        </v-layout>
                        </template>
                    </v-img>
                    </v-card>
                </v-col>
            </v-row>
            <p class="mt-3 text-xs-center"><a :href="`#/About Us/Senior Management/Profile/Permanent Secretary`" class="title">{{n.Title.split('#').length > 0 ? n.Title.split('#')[1] : ''}}</a><br>
            <span class="subheading text-xs-center">{{n.Title.split('#')[0]}}</span><br> </p>
        </div>
    </div>
</template>
<script>
    export default {
        props: ['contents']
    }
</script>